<script>
export default {
  methods: {
    goToSettings() {
      this.$router.push({
        name: 'settings'
      })
    }
  }
}
</script>